(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[262],{

/***/ 49438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ export_from_armenia; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./context/index.js + 6 modules
var context = __webpack_require__(64167);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/common/index.js + 82 modules
var common = __webpack_require__(35135);
// EXTERNAL MODULE: ./components/pages/index.js + 254 modules
var components_pages = __webpack_require__(4617);
// EXTERNAL MODULE: ./helpers/index.js + 6 modules
var helpers = __webpack_require__(69494);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./styles/pages/ExportFromArmeniaStyle.js

var ExportFromArmeniaStyle = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function (props) {
  return {
    className: props.className
  };
}).withConfig({
  componentId: "sc-1d6wmhb-0"
})(["display:flex;flex-direction:column;.no-result{display:flex;flex-direction:column;align-items:center;margin:var(--sp10x) auto 0;.imageCont{width:var(--sp18x);padding-top:var(--sp18x);}.title{margin:var(--sp5x) 0 var(--sp3x);}}.block{margin-top:var(--sp7x);position:relative;>.relativeWrapp{width:100%;margin:var(--sp10x) auto 0;}&.disable{.single-cat,.comp-title,.single-sel-location,.ant-slider{opacity:0.5;pointer-events:none;}}.list-head{display:flex;align-items:center;justify-content:space-between;}@media screen and (max-width:", "){.list-head{flex-direction:column;align-items:flex-end;}}@media screen and (max-width:", "){.filter-in-export-cont{margin-top:var(--sp14x);}.list-head{.search-field-cont{position:absolute;top:calc(-1 * var(--sp9x));}}}}@media screen and (min-width:", "){.block{display:flex;}}@media screen and (max-width:", "){.sort-by-cont{>.btn-action{position:absolute;top:0;right:0;}}.block{position:relative;}}@media screen and (max-width:", "){.sort-by-cont{>.btn-action{width:100%;}}.block{>.relativeWrapp{margin:var(--sp5x) auto 0;}}}"], function (props) {
  return props.theme.mediaQuery.DesktopSizeSMin;
}, function (props) {
  return props.theme.mediaQuery.LaptopSize;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.LaptopSizeMin;
}, function (props) {
  return props.theme.mediaQuery.TabletSizeMin;
});
/* harmony default export */ var pages_ExportFromArmeniaStyle = (ExportFromArmeniaStyle);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/export-from-armenia/index.js

var _excluded = ["pages", "products", "pageParams", "selectedLang", "router", "winWidth", "loading", "preloader"];
 //* HOC's


 //* Components


 //* Helpers

 //* Styles





var ExportFromArmenia = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var _pageData$content, _pageData$content$met, _pageData$content2, _pageData$content3, _pageData$filters2, _pageData$filters3, _pageData$filters4, _pageData$filters5, _pageData$content4, _pageData$content5;

  var pages = _ref.pages,
      products = _ref.products,
      pageParams = _ref.pageParams,
      selectedLang = _ref.selectedLang,
      router = _ref.router,
      winWidth = _ref.winWidth,
      loading = _ref.loading,
      preloader = _ref.preloader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  //! Page Data
  var pageData = (0,react.useMemo)(function () {
    var _pages$pageParams$nam;

    return pages === null || pages === void 0 ? void 0 : (_pages$pageParams$nam = pages[pageParams.name]) === null || _pages$pageParams$nam === void 0 ? void 0 : _pages$pageParams$nam[selectedLang];
  }, [pages, selectedLang, pageParams.name]);
  var productsData = (0,react.useMemo)(function () {
    var _products$pageParams$;

    return products === null || products === void 0 ? void 0 : (_products$pageParams$ = products[pageParams === null || pageParams === void 0 ? void 0 : pageParams.queryName]) === null || _products$pageParams$ === void 0 ? void 0 : _products$pageParams$[selectedLang];
  }, [products, selectedLang, pageParams.queryName]); //! States

  var _useState = (0,react.useState)(),
      secObj = _useState[0],
      setSecObj = _useState[1];

  var _useState2 = (0,react.useState)(),
      secObjIndividual = _useState2[0],
      setSecObjIndividual = _useState2[1]; //! Refs


  var TitleRef = (0,react.useRef)();
  var Ref1 = (0,react.useRef)();
  var Ref2 = (0,react.useRef)();
  var Ref3 = (0,react.useRef)();
  var Ref4 = (0,react.useRef)(); //! Filter Change

  var onCategoryChange = (0,react.useCallback)(function (cat, catId) {
    var multiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var clearKeyItems = arguments.length > 3 ? arguments[3] : undefined;

    var _routerToPathAndQuery = (0,helpers/* routerToPathAndQuery */.Br)(router, cat, catId, multiple, clearKeyItems),
        pathname = _routerToPathAndQuery.pathname,
        query = _routerToPathAndQuery.query;

    multiple && delete query[pageParams.postType.queryParamKeys[2]]; //? Page Param Removed on Category Change

    router.push({
      pathname: pathname,
      query: query
    }, undefined, {
      scroll: true
    });
  }, [router.query]); //! Animation

  (0,react.useEffect)(function () {
    var _Ref3$current, _Ref4$current;

    if (pageData && productsData && !loading && TitleRef !== null && TitleRef !== void 0 && TitleRef.current && Ref1.current[1] && Ref2 !== null && Ref2 !== void 0 && Ref2.current && Ref3 !== null && Ref3 !== void 0 && (_Ref3$current = Ref3.current) !== null && _Ref3$current !== void 0 && _Ref3$current[2] && Ref4 !== null && Ref4 !== void 0 && (_Ref4$current = Ref4.current) !== null && _Ref4$current !== void 0 && _Ref4$current[3] && !preloader) {
      setSecObjIndividual([Ref4.current[3].current[0].childNodes]);
      winWidth >= 1024 ? setSecObj([Ref1.current[0].current, Ref1.current[1].current, (0,helpers/* arrayGenChild */.YJ)(TitleRef.current.childNodes[0].childNodes), Ref2.current, (0,helpers/* arrayGenChild */.YJ)(Ref3.current[0][0].childNodes), Ref3.current[1].current, Ref3.current[2].current, (0,helpers/* arrayGenChild */.YJ)(Ref4.current[0].current.childNodes[0].childNodes), Ref4.current[1].current.childNodes, Ref4.current[2].current.childNodes, (0,helpers/* arrayGen */.vN)([[Ref4.current[3].current[1]], Ref4.current[3].current[2], Ref4.current[3].current[3]])]) : setSecObj([(0,helpers/* arrayGenChild */.YJ)(TitleRef.current.childNodes[0].childNodes), (0,helpers/* arrayGenChild */.YJ)(Ref3.current[0][0].childNodes), Ref3.current[1].current, Ref3.current[2].current, Ref2.current, (0,helpers/* arrayGenChild */.YJ)(Ref4.current[0].current.childNodes[0].childNodes), Ref4.current[1].current.childNodes, Ref4.current[2].current.childNodes, (0,helpers/* arrayGen */.vN)([[Ref4.current[3].current[1]], Ref4.current[3].current[2], Ref4.current[3].current[3]])]);
    }
  }, [TitleRef.current, Ref1.current, Ref2.current, Ref3.current, Ref4.current, pageData, productsData, loading, router, winWidth, preloader]);
  var catalogue = (0,react.useMemo)(function () {
    if (loading) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relativeWrapp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Preloader */.p9, {
          className: 'preloaderProductProject'
        })
      });
    } else {
      var _pageData$filters;

      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_pages/* ExportCatalog */.ml, {
          ref: Ref2,
          onPageChange: onCategoryChange,
          sorts: pageData === null || pageData === void 0 ? void 0 : (_pageData$filters = pageData.filters) === null || _pageData$filters === void 0 ? void 0 : _pageData$filters.sorts,
          catalogsArr: productsData === null || productsData === void 0 ? void 0 : productsData.products,
          total: productsData === null || productsData === void 0 ? void 0 : productsData.total,
          itemsCountPerPage: productsData === null || productsData === void 0 ? void 0 : productsData.perPageCount,
          queryParamKeys: pageParams.postType.queryParamKeys,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "no-result",
            ref: Ref2,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common/* Image */.Ee, {
              src: "/images/noResult.svg",
              alt: props.translate('noResult')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
              tag: 'h5',
              className: 'title h5 MonRegular black',
              text: 'noResult'
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
              tag: 'p',
              className: 'pM MonRegular ultraDarkGrey',
              text: 'noResultText'
            })]
          })
        })
      });
    }
  }, [productsData, loading]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(pages_ExportFromArmeniaStyle, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Page */.T3, {
      className: "export-from-armenia",
      meta: {
        title: pageData === null || pageData === void 0 ? void 0 : (_pageData$content = pageData.content) === null || _pageData$content === void 0 ? void 0 : (_pageData$content$met = _pageData$content.meta) === null || _pageData$content$met === void 0 ? void 0 : _pageData$content$met.title,
        description: pageData === null || pageData === void 0 ? void 0 : (_pageData$content2 = pageData.content) === null || _pageData$content2 === void 0 ? void 0 : _pageData$content2.meta.description,
        keywords: pageData === null || pageData === void 0 ? void 0 : (_pageData$content3 = pageData.content) === null || _pageData$content3 === void 0 ? void 0 : _pageData$content3.meta.keywords,
        image: pageData === null || pageData === void 0 ? void 0 : pageData.content.meta_image
      },
      children: pageData && /*#__PURE__*/(0,jsx_runtime.jsxs)(common/* AnimationWrapp */.dh, {
        state: secObj,
        formItems: secObjIndividual,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(common/* Container */.W2, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
            tag: 'stringToLetters',
            className: 'title h1 MonBold',
            text: 'exportProduct',
            ref: TitleRef
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "block ".concat(loading ? 'disable' : ''),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_pages/* FilterInExport */.Ct, {
              onCategoryChange: onCategoryChange,
              categories: (_pageData$filters2 = pageData.filters) === null || _pageData$filters2 === void 0 ? void 0 : _pageData$filters2.categories,
              types: (_pageData$filters3 = pageData.filters) === null || _pageData$filters3 === void 0 ? void 0 : _pageData$filters3.subcategories,
              countries: (_pageData$filters4 = pageData.filters) === null || _pageData$filters4 === void 0 ? void 0 : _pageData$filters4.countries,
              unitPrices: (_pageData$filters5 = pageData.filters) === null || _pageData$filters5 === void 0 ? void 0 : _pageData$filters5.unitPrices,
              queryParamKeys: pageParams.postType.queryParamKeys,
              ref: Ref1
            }), catalogue]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_pages/* ContactSection */.U0, {
          ref: Ref3,
          title: (_pageData$content4 = pageData.content) === null || _pageData$content4 === void 0 ? void 0 : _pageData$content4.section_2_title,
          text: (_pageData$content5 = pageData.content) === null || _pageData$content5 === void 0 ? void 0 : _pageData$content5.section_2_text,
          url: helpers/* config.routes.whatIsaProductSubmission.path */.vc.routes.whatIsaProductSubmission.path,
          linkText: 'contactUsBtn',
          singlePage: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_pages/* Calculator */.yg, {
          ref: Ref4,
          calcData: pageData.potentialCalculator,
          title: pageData.content.section_3_title,
          rightText: pageData.content.section_3_right_text,
          leftText: pageData.content.section_3_left_text
        })]
      })
    })
  });
});
/* harmony default export */ var export_from_armenia = ((0,router.withRouter)((0,context/* withUIContext */.pP)((0,context/* withLanguageContext */.VZ)((0,context/* withDataContext */.hX)(ExportFromArmenia, ['products', 'pages']), ['selectedLang', 'translate']), ['winWidth', 'loading'])));

/***/ }),

/***/ 46637:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/export-from-armenia",
      function () {
        return __webpack_require__(49438);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(46637); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);